import { gql } from '@apollo/client';

import { DETAILED_DATA_REPORT_FILTERS } from './fragments/detailedDataReportFilters';
import { REPORT_COMMON_FIELDS } from './fragments/reportCommonFields';
import { STANDARD_DELIVERY_DEVICE_HIGHER_CATEGORY_REPORT_FILTERS } from './fragments/standardDeliveryDeviceHigherCategoryReportFilters';
import { STANDARD_DELIVERY_REPORT_FILTERS } from './fragments/standardDeliveryReportFilters';

export const TEMPLATES_WITH_REPORTS = gql`
  query TemplatesWithReports($orgId: ID!, $advertiserId: String) {
    templatesWithReports(orgId: $orgId, advertiserId: $advertiserId) {
      id
      name
      systemName
      totalScheduled
      description
      lastUpdatedAt
      reports {
        ...reportCommonFields
        filters {
            ... on StandardDeliveryReportFilters {
                ...standardDeliveryReportFilters
            }
            ... on StandardDeliveryDeviceHigherCategoryReportFilters {
                ...standardDeliveryDeviceHigherCategoryReportFilters
            }
            ... on DetailedDataReportFilters {
                ...detailedDataReportFilters
            }
        }
      }
    }
  }
  ${REPORT_COMMON_FIELDS},
  ${STANDARD_DELIVERY_REPORT_FILTERS},
  ${STANDARD_DELIVERY_DEVICE_HIGHER_CATEGORY_REPORT_FILTERS},
  ${DETAILED_DATA_REPORT_FILTERS}
`;
